import { z } from 'zod';

export const moneyStringValidationMessages = {
  required: 'Required',
};

export const moneyStringSchema = z.string({
  error: moneyStringValidationMessages.required,
});
